import React from "react";
import "./AuditorsReport.scss";
import aReport1 from "../../../assets/Reports/Auditor's Report 1.png";
import aReport2 from "../../../assets/Reports/Auditor's Report 2.png";
import aReport3 from "../../../assets/Reports/Auditor's Report 3.png";
import aReport4 from "../../../assets/Reports/Auditor's Report 4.png";
import aReport5 from "../../../assets/Reports/Auditor's Report 5.png";

const AuditorsReport = () => {
  return (
    <>
      <div className="auditors_report">
        <div className="container">
          <div className="heading_box">Auditors Report</div>
          <div className="my-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={aReport1} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={aReport2} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={aReport3} className="img-fluid " alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={aReport4} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3">
                <img src={aReport5} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuditorsReport;
